var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-add-button flex",class:{
        'bottom-btn': _vm.isHabitation,
        'safe-area-inset-bottom': _vm.safeAreaInset
    }},[_c('van-button',{staticClass:"btn font-bold",attrs:{"loading":_vm.btnLoading,"loading-type":"circular","loading-text":_vm.loadingText},on:{"click":_vm.config}},[(!_vm.btnText)?_vm._t("content"):_c('div',{staticClass:"btn-text font-34 btn"},[_vm._v(_vm._s(_vm.btnText))])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }